var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVideoCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_video",
    "data-name": "vuesax/bold/video",
    transform: "translate(-108 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(108 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.633,3.407a2.624,2.624,0,0,0-2.847.432L18.072,5.052C17.943,1.423,16.368,0,12.542,0h-7C1.552,0,0,1.552,0,5.542v9.333c0,2.683,1.458,5.542,5.542,5.542h7c3.827,0,5.4-1.423,5.53-5.052l1.715,1.213a3.21,3.21,0,0,0,1.855.677,2.122,2.122,0,0,0,.992-.245,2.633,2.633,0,0,0,1.283-2.578V5.985A2.633,2.633,0,0,0,22.633,3.407ZM10.792,9.485a2.193,2.193,0,1,1,2.193-2.193A2.2,2.2,0,0,1,10.792,9.485Z",
    transform: "translate(2.802 3.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoCamera);
export default __webpack_public_path__ + "static/media/icon-video-camera.637a5d2219a7c4e242632c83cd272b8c.svg";
export { ForwardRef as ReactComponent };